import * as React from 'react'
import './privacy.scss'
const privacy = () => {
  return <iframe title='隐私政策' className='p-privacy' src='https://baleen-cdn-g.bybieyang.com/static/html/privacy.html'></iframe>
}

export default privacy